import { acceptInvite } from 'api/invites.api';
import { validatePassword } from 'utils/validatePassword';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from 'utils/firebase';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import { validateEmail } from 'utils/validateEmail';
import { createUser } from 'api/users.api';
import { updateTeam } from 'api/teams.api';

export const handleSubmitAcceptInvite = async (token) => {
  $view.update({ isLoading: true });

  const { email, password, confirmPassword } = $form.value;
  const emailValidation = validateEmail(email);
  const passwordValidation = validatePassword(password);
  const errs = [...emailValidation, ...passwordValidation];

  try {
    if (errs.length) throw new Error(errs[0]);
    if (password !== confirmPassword) throw new Error('Passwords do not match');

    $user.update({
      isCreatingUser: true,
    });

    const { user: fbUser } = await createUserWithEmailAndPassword(auth, email, password);

    const inviteData = await acceptInvite({ token });
    console.info('Invite Data:', inviteData);
    const { id } = await createUser({
      uid: fbUser.uid,
      email: fbUser.email,
      userTypeId: inviteData.userTypeId,
      firstName: $form.value.firstName,
      lastName: $form.value.lastName,
      companyName: $form.value.companyName,
      organizationId: inviteData.organizationId,
      onboardingStep: 'completed',
    });

    if (inviteData.teamId) {
      await updateTeam(inviteData.teamId, {
        users: [...inviteData.teamUsers, id],
      });
    }
    const redirectUrl = inviteData.userTypeId === 1 ? '/investor/profile' : '/founder/profile';
    window.location.href = redirectUrl;
  } catch (error) {
    displayError({
      message: 'Failed to accept invitation. Please check your information and try again.',
      title: 'Invitation Error',
    });
  } finally {
    $view.update({ isLoading: false });
  }
};
